import makeStyles from 'e100-react-components/lib/styles/makeStyles';

const useStyles = makeStyles(() => ({
  container: {
    overflowY: 'auto',
    height: '100%'
  }
}));

export default useStyles;